var SRLiveAdapter = window.SRLiveAdapter = (function () {
	var SRLive: any;

    function init(SRLiveInst: any) {
		SRLive = SRLiveInst;
		var event = document.createEvent('Event');
		var initEvent = event.initEvent('initSRLive', false, true);
        document.dispatchEvent(event);
    }

    function addWidget(params: Object) {
        return new Promise((resolve, reject) => {
            if (!SRLive) {
                document.addEventListener('initSRLive', function () {
                    resolve(SRLive.addWidget(params));
                });
            } else {
                resolve(SRLive.addWidget(params));
            }
        });
    }

    function stopWidget(widget: Object) {
        if (SRLive) {
            var SRWidget = SRLive.getWidget(widget);
            if (SRWidget) SRWidget.pauseFeeds();
        }
        return;
    }

    function resumeWidget(widget: Object) {
        if (SRLive) {
            var SRWidget = SRLive.getWidget(widget);
            if (SRWidget) SRWidget.resumeFeeds(true);
        }
        return;
    }

    function removeWidget(widget: Object) {
        if (SRLive) {
            SRLive.removeWidget(widget);
        }
    }

    function isSRLiveReady() {
        return SRLive ? true : false;
    }

    function getSRLive() {
        return SRLive;
    }

    return {
        init,
        addWidget,
        stopWidget,
        resumeWidget,
        removeWidget,
        isSRLiveReady,
        getSRLive
    }
}());